import { forwardRef, useImperativeHandle, useState, useRef, useEffect } from 'react';
import { ICellEditorParams } from 'ag-grid-community';
import InputNumber from 'lib/InputNumber';

export const InputNumberCellEditor = forwardRef<unknown, ICellEditorParams>((props, ref) => {
  const {
    value: { value: initialValue },
    colDef: {
      cellRendererParams: { decimalPlaces = 0 },
    },
  } = props;
  const [value, setValue] = useState<number | undefined>(initialValue ?? undefined);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    inputRef.current?.focus();
    inputRef.current?.select();
  }, []);

  useImperativeHandle(ref, () => ({
    getValue: () => value,
    isCancelBeforeStart: () => false,
    isCancelAfterEnd: () => false,
  }));

  const handleChange = (newValue: number | undefined): void => {
    setValue(newValue);
  };

  return (
    <InputNumber
      inputRef={inputRef}
      value={value}
      onChange={handleChange}
      min={1}
      maximumFractionDigits={decimalPlaces}
      isEmpty
    />
  );
});

InputNumberCellEditor.displayName = 'InputNumberCellEditor';
